import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { TranslateSafePipe } from '../../pipes/translation.pipe';
import { ButtonIconComponent } from '../button-icon/button-icon.component';

@Component({
  selector: 'app-image-gallery',
  imports: [
    ButtonIconComponent,
    TranslateSafePipe,
  ],
  templateUrl: './image-gallery.html',
  styleUrl: './image-gallery.css',
})
export class ImageGallery {
  public readonly imagePath: string = environment.imageUrl;

  @Input()
  public imageList: string[] = [];

  @Input()
  public showDelete: boolean = true;

  @Input()
  public readonly: boolean = false;

  @Output()
  public remove: EventEmitter<number> = new EventEmitter<number>();

  constructor(
    private _domSanitizer: DomSanitizer
  ) {

  }

  public removeImage(index: number): void {
    if (this.readonly) return;

    this.remove.emit(index);
  }

  public bypassUrl(imageUrl: string): SafeUrl {
    return this._domSanitizer.bypassSecurityTrustUrl(imageUrl);
  }
}
